import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBZEL7EG.js";

// src/icons/QuestionMarkIcon.tsx
import SvgIcon from "@mui/joy/SvgIcon";
import { jsx } from "react/jsx-runtime";
var QuestionMarkIcon = (props) => {
  const Svg = () => /* @__PURE__ */ jsx("path", { d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z" });
  return /* @__PURE__ */ jsx(SvgIcon, __spreadProps(__spreadValues({}, props), { viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Svg, {}) }));
};
var QuestionMarkIcon_default = QuestionMarkIcon;

export {
  QuestionMarkIcon_default
};
